import { LineChart, Database, Brain, BarChart3 } from 'lucide-react';

export const services = [
  {
    icon: LineChart,
    title: "Predictive Analytics",
    description: "Using historical data to forecast future trends and enhance data-driven decision-making.",
    gradient: "from-[#ff6600] to-orange-500"
  },
  {
    icon: Database,
    title: "Data Integration & Automation",
    description: "Streamlining data across your organization to ensure seamless operations with data modeling and cloud-based data solutions.",
    gradient: "from-orange-500 to-[#ff6600]"
  },
  {
    icon: Brain,
    title: "AI-Driven Recommendation Systems",
    description: "Personalizing user experiences to increase customer engagement and conversion rates.",
    gradient: "from-[#ff6600] to-orange-600"
  },
  {
    icon: BarChart3,
    title: "Business Intelligence Solutions",
    description: "Providing comprehensive data analysis and visualization tools for better business insights.",
    gradient: "from-orange-600 to-[#ff6600]"
  }
];
